import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {OrderComponent} from './order.component';
import {OrderDetailComponent} from '../order-detail/order-detail.component';
import {LoginGuard} from '../login/login.guard';

const routes: Routes = [{
    path: 'order',
    component: OrderComponent,
    canActivate : [LoginGuard]
  },
  {
    path: 'order/new',
    component: OrderDetailComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'order/:id',
    component: OrderDetailComponent,
    canActivate: [LoginGuard]
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrderRoutingModule { }



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/order/order-routing.module.ts